
  import { defineComponent, ref, onMounted } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import { Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import Editor from '@tinymce/tinymce-vue';
  import { AboutUsObject } from '@/store/modules/settings/AboutUsModule';

  export default defineComponent({
    name: 'about-us-editing',
    components: {
      editor: Editor,
      Form,
    },

    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const route = useRoute();
      const { can } = useAbility();
      const submitButton = ref<HTMLButtonElement | null>(null);
      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };
      store.dispatch(Actions.ADD_BODY_CLASSNAME, 'page-loading');

      setTimeout(() => {
        // Remove page loader after some time
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading');
      }, 1000);

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('aboutUsUpdating'), [
          translate('settings'),
        ]);
      });

      const { data } = await store.dispatch(
        Actions.GET_ABOUT_US_BY_ID,
        route.params.id
      );

      const aboutUs = ref<AboutUsObject>(data.data);

      console.log(aboutUs.value.htmlAr);
      const goBack = () => {
        router.back();
      };

      const onSubmitUpdate = async () => {
        if (submitButton.value) {
          // eslint-disable-next-line
          submitButton.value!.disabled = true;
          submitButton.value.setAttribute('data-kt-indicator', 'on');
        }
        await store.dispatch(Actions.UPDATE_ABOUT_US, {
          id: aboutUs.value?.id,
          data: {
            htmlAr: aboutUs.value.htmlAr,
            htmlEn: aboutUs.value.htmlEn,
            htmlKu: aboutUs.value.htmlKu,
            type: aboutUs.value.type,
          },
        });
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];

        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
          //Deactivate indicator
          submitButton.value?.removeAttribute('data-kt-indicator');
          // eslint-disable-next-line
          submitButton.value!.disabled = false;
        } else {
          Swal.fire({
            text: translate('SUCCESSFULLY_UPDATED_ABOUT_US'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          }).then(() => {
            router.push({ name: 'about-us-listing' });
          });
        }
      };

      return {
        translate,
        aboutUs,
        goBack,
        submitButton,
        onSubmitUpdate,
        can,
      };
    },
  });
